import { addDays, format, startOfDay } from "date-fns";
import { getDateLib } from "react-day-picker/persian";

/** Inclusive max length the calendar endpoint accepts. */
export const PDP_CALENDAR_MAX_DAYS = 62;

export const toDateString = (date: Date): string => format(date, "yyyy-MM-dd");

export interface PdpCalendarWindow {
  from: Date;
  to: Date;
  fromString: string;
  toString: string;
}

/**
 * Selectable PDP window: today through the earlier of two Jalali months
 * ahead and today + 61 days, so the calendar GET never exceeds 62 inclusive days.
 */
export function getPdpCalendarWindow(now = new Date()): PdpCalendarWindow {
  const from = startOfDay(now);
  const twoMonthsAhead = startOfDay(getDateLib().addMonths(from, 2));
  const apiCap = addDays(from, PDP_CALENDAR_MAX_DAYS - 1);
  const to = twoMonthsAhead.getTime() < apiCap.getTime() ? twoMonthsAhead : apiCap;

  return {
    from,
    to,
    fromString: toDateString(from),
    toString: toDateString(to),
  };
}
